<template>
  <block-item-card
    :min-height="minBlockHeight"
    :title="$t('RiskLiquidity.Section.RealTimeMonitoring.Title')"
    :tooltip="$t('RiskLiquidity.Section.RealTimeMonitoring.Tooltip')"
  >
    <v-row
      class="ma-0 px-2 pb-2"
      no-gutters
    >
      <v-col
        class="ma-0 pa-2"
        cols="12"
      >
        <social-media-mentions />
      </v-col>
      <v-col
        class="ma-0 pa-2"
        cols="12"
      >
        <market-price-action />
      </v-col>
    </v-row>
  </block-item-card>
</template>

      <script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import SocialMediaMentions from '@/theme/default/views/banking/risk/liquidity/risk-monitoring/real-time-monitoring/SocialMediaMentions.vue'
import MarketPriceAction from '@/theme/default/views/banking/risk/liquidity/risk-monitoring/real-time-monitoring/MarketPriceAction.vue'

export default {
  name      : 'RealTimeMonitoring',
  components: {
    BlockItemCard,
    SocialMediaMentions,
    MarketPriceAction
  },
  props: {},
  data () {
    return {
      minBlockHeight: 350
    }
  }
}
  </script>

  <style scoped>
  </style>
